<template>
	<div style="min-width: 500px; min-height: 200px;">
		<div v-if="!isLoading">
			<div>
				<BaseSelect
					class="w-1/2"
					ref="BaseSelect"
					required="true"
					:label="$t('damage_assessor')"
					:options="damageAssessorOptions"
					v-model="selectedDamageAssessor"
					:allow-empty="false"
				/>
			</div>
			<div class="flex justify-end">
				<SaveButton @click="swapDamageAssessor" class="mb-4 btn-blue" :disabled="!selectedDamageAssessor">{{ $t('general.save') }}</SaveButton>
			</div>
		</div>
		<LoadingSpinner v-else />
	</div>
</template>
<script>
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';
import { getGermanDate } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';
import CompanyRepository from '@/api/repositories/CompanyRepository';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import BaseDatepicker from '@/components/forms/inputs/BaseDatepicker.vue';

export default {
	name: 'ChangeAssessorModal',
	components: { BaseDatepicker, SaveButton, BaseSelect, LoadingSpinner },
	mixins: [Authentication],
	data() {
		return {
			damageAssessorCase: {},
			isLoading: true,
			damageAssessorOptions: [],
			selectedDamageAssessor: null,
			originalDamageAssessor: null,
		};
	},
	computed: {
		hasChanges() {
			return this.originalDamageAssessor.id !== this.selectedDamageAssessor.id;
		},
	},
	watch: {
		hasChanges(value) {
			this.$store.commit('setConfirmLeaving', value ? this.$t('leave_page') : false);
		},
	},
	mounted() {
		this.isLoading = true;
		this.getDamageAssessorCaseData();
	},
	destroyed() {
		this.$store.commit('setConfirmLeaving', false);
	},
	methods: {
		getGermanDate,
		getDamageAssessorCaseData() {
			new DamageAssessorCaseRepository()
				.getDamageAssessorCaseDetail(this.$route.params.id)
				.then(response => {
					this.damageAssessorCase = response.data;
					this.isLoading = false;
				})
				.catch(e => {
					this.isLoading = false;
				})
				.then(_ => {
					this.getEmployees();
				});
		},
		getEmployees() {
			new DamageAssessorCaseRepository().getCompanyEmployees(this.$store.getters.getUser.person.company.id).then(response => {
				this.damageAssessorOptions = response.data.data.map(element => {
					return {
						value: element.person.personableId,
						display: element.person.firstName + ' ' + element.person.lastName,
					};
				});
				if (this.damageAssessorCase.damage_assessor) {
					this.selectedDamageAssessor = this.damageAssessorOptions.find(element => element.value === this.damageAssessorCase.damage_assessor.id);
					this.originalDamageAssessor = this.selectedDamageAssessor ? this.selectedDamageAssessor : null;
				}
			});
		},
		swapDamageAssessor() {
			if (this.selectedDamageAssessor) {
				this.isLoading = true;
				new DamageAssessorCaseRepository()
					.swapDamageAssessor(this.$route.params.id, this.selectedDamageAssessor.value)
					.then(response => {
						this.isLoading = false;
						this.$root.$emit('updateCase');
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success').then(_ => {
							this.$router.go(-1);
						});
					})
					.catch(e => {
						this.isLoading = false;
						this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
					});
			}
		},
	},
};
</script>
